// DMN validator. Runs a pluggable list of rule functions over a moddle
// definitions tree and returns a flat list of issues.
//
//   const v = new Validator();
//   const issues = v.validate(definitions);
//
// Custom rules can be added/removed via `addRule` / `removeRule`. Each rule is
// a function (context) → Issue[] where context = { definitions, drgElements,
// byId }.

import { DEFAULT_RULES } from './rules';

export class Validator {
  constructor({ rules } = {}) {
    this._rules = rules ? [...rules] : [...DEFAULT_RULES];
  }

  addRule(fn) { this._rules.push(fn); }
  removeRule(fn) { this._rules = this._rules.filter((r) => r !== fn); }
  getRules() { return [...this._rules]; }

  validate(definitions) {
    if (!definitions) return [];
    const drgElements = definitions.drgElement || [];
    const byId = new Map(drgElements.map((el) => [el.id, el]));
    const context = { definitions, drgElements, byId };
    const out = [];
    this._rules.forEach((rule) => {
      try {
        const issues = rule(context) || [];
        issues.forEach((i) => out.push(i));
      } catch (err) {
        out.push({
          id: `rule_err_${Math.random().toString(36).slice(2)}`,
          severity: 'warning',
          ruleId: 'rule-crash',
          elementId: null,
          message: `Rule '${rule.name}' crashed: ${err.message}`,
        });
      }
    });
    return out;
  }
}
